export const getTwoFaPanelStyle = (theme) => ({
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
});